import { SVGProps } from 'react'

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    viewBox="0 0 13 13"
    {...props}
  >
    <path d="M6.103.005A1 1 0 0 1 7 1v4h2V3.5a.5.5 0 0 1 1 0V5h2l.102.005A1 1 0 0 1 13 6v6l-.005.102a1 1 0 0 1-.893.893L12 13H1l-.103-.005a1 1 0 0 1-.892-.893L0 12V1A1 1 0 0 1 .897.005L1 0h5l.103.005ZM7 12h5V6H7v6Zm-6 0h1v-2a1 1 0 0 1 .897-.995L3 9h1l.103.005A1 1 0 0 1 5 10v2h1V1H1v11Zm2 0h1v-2H3v2Z" />
  </svg>
)
export default SvgComponent
